module.exports = {"title":"Stream","description":"Event Information","artists":"Artists","playbillder":"Event Program/Playbill"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/StreamNavigation/locales/en.json
// module id = 819
// module chunks = 0